import ReactDOM from 'react-dom'; // TODO: https://github.com/salute-developers/plasma/issues/233
// eslint-disable-next-line @typescript-eslint/no-explicit-any

var _ref = ReactDOM,
    flushSync = _ref.flushSync;
export var IS_REACT_18 = /*#__PURE__*/ReactDOM.version.split('.')[0] === '18';
export function safeFlushSync(fn) {
  if (!IS_REACT_18) {
    return fn();
  }

  return flushSync(fn);
}